import { makeCommsPage } from './commsPage'
import { CommsMailboxesView } from '../components/views/commsMailboxesView'

export default makeCommsPage({
    title: 'Mailboxes',
    intro: 'Shared mailboxes swept for inbound lender and client email. Watch backfill progress, include or exclude folders, and re-sweep when something is missed.',
    probeUrl: 'comms/mailboxes/list',
    View: CommsMailboxesView,
    className: 'commsMailboxes',
})
